import {useRouter} from 'next/router'
import {ReactNode, useEffect} from 'react'

import {AppLinkerProvider as ExternalAppLinkerProvider, useAppLinker} from '@pie/app-linker'

import {EXTERNAL_ROUTES} from '$constants/external-routes'
import QRBridgeTitle, {QRType} from '$constants/insurance/qrBridgeTitle'
import {PROFILE} from '$share/config'
import buildUrl from '$utils/buildUrl'

import '@pie/app-linker/dist/index.css'

function AppLinker() {
    const {showAppLinker, hideAppLinker} = useAppLinker()
    const router = useRouter()

    useEffect(() => {
        const {showAppDownloadQR, appBridgeUrl, qrType, ...restQueries} = router.query as Record<string, string>

        const onClose = () => {
            router.replace({pathname: router.pathname, query: restQueries}, undefined, {shallow: true})
        }

        const landingUrl =
            typeof appBridgeUrl === 'string' && appBridgeUrl
                ? buildUrl({baseUrl: appBridgeUrl, query: restQueries})
                : buildUrl({pathname: EXTERNAL_ROUTES.MYDATA.HOME, withBasePath: false})

        const qrTitle =
            qrType && qrType in QRBridgeTitle ? QRBridgeTitle[qrType as QRType] : QRBridgeTitle[QRType.MY_ASSET]

        showAppDownloadQR === 'true'
            ? showAppLinker({
                  title: qrTitle,
                  landingUrl,
                  onClose,
              })
            : hideAppLinker()
    }, [hideAppLinker, router, showAppLinker])

    return null
}

export default function AppLinkerProvider({children}: {children: ReactNode}) {
    return (
        <ExternalAppLinkerProvider phase={PROFILE}>
            {children}
            <AppLinker />
        </ExternalAppLinkerProvider>
    )
}
